import React, { useMemo, useState } from 'react';
import ReactQuill from 'react-quill';
import DOMPurify from 'dompurify';
import 'react-quill/dist/quill.snow.css';
import './LegalEditor.css';

const MODULES = { toolbar: [[{ header: [1, 2, 3, false] }], ['bold', 'italic', 'underline', 'strike'], [{ list: 'ordered' }, { list: 'bullet' }], [{ align: [] }, { direction: 'rtl' }], ['blockquote', 'link'], ['clean']] };
const TAGS = ['h1','h2','h3','h4','h5','h6','p','br','strong','b','em','i','u','s','ul','ol','li','blockquote','div','span','a','hr','table','thead','tbody','tr','th','td'];

export default function LegalEditor({ language, value, onChange, disabled }) {
  const [mode, setMode] = useState('visual');
  const safeHtml = useMemo(() => DOMPurify.sanitize(value, { ALLOWED_TAGS: TAGS, ALLOWED_ATTR: ['class', 'dir', 'style', 'href', 'title'], ALLOW_DATA_ATTR: false }), [value]);
  const label = `${language === 'en' ? 'English' : 'Arabic'} — full document`;
  return <section className="legal-editor" dir={language === 'ar' ? 'rtl' : 'ltr'}>
    <h5>{label}</h5>
    <div className="legal-editor__modes" aria-label={`${label} editor mode`}>
      {['visual', 'html', 'preview'].map(choice => <button type="button" key={choice} disabled={disabled}
        className={`btn btn-sm ${mode === choice ? 'btn-primary' : 'btn-outline-secondary'}`} aria-pressed={mode === choice}
        onClick={() => setMode(choice)}>{choice === 'html' ? 'HTML' : choice === 'visual' ? 'Visual editor' : 'Preview'}</button>)}
    </div>
    {mode === 'visual' && <ReactQuill key={language} theme="snow" value={safeHtml} modules={MODULES} readOnly={disabled}
      onChange={(html, delta, source) => { if (source === 'user') onChange(html); }} />}
    {mode === 'html' && <textarea aria-label={`${label} HTML`} className="form-control legal-editor__source" dir="ltr"
      rows={26} maxLength={100000} disabled={disabled} value={value} onChange={event => onChange(event.target.value)} />}
    {mode === 'preview' && <div className="legal-editor__preview" dangerouslySetInnerHTML={{ __html: safeHtml }} />}
  </section>;
}
